<script>
import EssayModal from "@/components/modals/essay-modal.vue";
import EssayViewModal from "@/components/modals/essay-view-modal.vue";
import EssayActionModal from "@/components/modals/essay-actions-modal.vue";
import EssayPdfViewModal from "../modals/essay-pdf-view-modal.vue";
import api from "@/helpers/api-rest/api.js";
import store from "@/state/store";
import Swal from "sweetalert2";
import statusHelper from "@/helpers/general/status.js";

export default {
  components: {
    EssayModal,
    EssayViewModal,
    EssayActionModal,
    EssayPdfViewModal,
  },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      essayModalId: "ModalEssay",
      essayViewModalId: "ModalViewEssay",
      essayActionModalId: "ModalActionEssay",
      essayEdit: undefined,
      isBusy: false,
      totalItems: 0,
      isModalActive: false,
      currentStep: 0,
      listEssays: [],
      actionType: "",
      essayId: null,
      action: {},
      essayURL: "",
      statusHelper,
    };
  },
  props: {
    id: null,
    fields: {
      type: Array,
      required: true,
    },
    rows: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    this.loadData();
    this.totalRows = this.listEssays.length;
  },
  // computed: {
  //   /**
  //    * Total no. of records
  //    */
  //   rows() {
  //     return this.listEssays.length;
  //   }
  // },
  methods: {
    showElement(roleId = [], show = true, showEdit = true) {
      const role = store.getters["auth/role"];
      if (roleId.includes(role.id) && show && showEdit) {
        return true;
      }
      return false;
    },
    showFinalStepIcon(essay, roleId = []) {
      const role = store.getters["auth/role"];
      return essay.current_step === 3 && roleId.includes(role.id);
    },
    async loadData() {
      this.isBusy = true;
      try {
        this.showElement();
        const apiEndpoint = `/api/v1/essays?project_id=${this.id}`;
        const response = await api.get({
          url: apiEndpoint,
        });
        // const data = response?.data?.data;
        const data = response?.data?.data.map((essay) => ({
          ...essay,
          createdBy: essay.created_by.name,
          essayStatus: essay.essay_status.name,
          course_ids: essay.courses.map((item) => item.id),
        }));

        this.totalRows = data.length;
        this.listEssays = data;
        this.isBusy = false;
        return data;
      } catch (error) {
        this.isBusy = false;
        console.error("Error loading data (project_id):", error);
        return [];
      }
    },
    success(essay) {
      console.log(essay);
    },
    viewEssay(essay) {
      this.essayEdit = essay;

      this.$bvModal.show(this.essayViewModalId);
    },
    editEssay(essay) {
      if (!essay.essay_coordinator) {
        essay.essay_coordinator = {
          center_id: null,
          essay_professorates: [],
          document_name: "",
        };
      }

      if (!essay.targets) {
        essay.targets = [];
      }

      // Modifica solo los targets
      essay.targets = essay.targets.map((target) => ({
        ...target,
        title: target.title || "",
        target_results: target.target_results || [],
        target_achievements: target.target_achievements || [],
      }));

      this.essayEdit = essay;
      this.$bvModal.show(this.essayModalId);
      this.isModalActive = true;
      // Ensure currentStep is always a valid number
      this.currentStep = essay.current_step !== null && essay.current_step !== undefined 
        ? Number(essay.current_step) 
        : 0;
    },

    // },
    addEssay() {
      const currentDate = new Date().toISOString().slice(0, 10);
      this.essayEdit = {
        id: null,
        name: "",
        description: "",
        antecedentes: "",
        arte_status: "",
        type: null,
        current_step: 0,
        courses: [],
        course_ids: [],
        essay_coordinator: {
          center_id: null,
          document_name: null,
          document_path: null,
          essay_professorates: [],
        },
        targets: [
          {
            title: "",
            description: "",
            target_results: [
              {
                id: "",
                target_id: "",
                title: "",
                description: "",
                quantitative_qualitative_assessment: "",
                products_realized: "",
                educational_community_impact: "",
                transferability_to_other_centers: "",
                other_expected_results: "",
                communications_conferences: "",
                exploitation_licenses_patents: "",
                agreements_networks_proposals: "",
              },
            ],
          },
        ],
        actions: [
          {
            id: "",
            name: "",
            descriptions: "",
            init_date: currentDate,
            end_date: currentDate,
            responsables: "",
            risks: "",
            contingency_plan: "",
            essay_id: this.essayEdit?.id,
            education_activities: [],
            economic_forecats: [],
          },
        ],
      };
      this.$bvModal.show(this.essayModalId);
      this.isModalActive = true;
      this.currentStep = 0;
    },
    viewPDF() {
      this.$bvModal.show("ModalViewPDF");
    },
    handleModalClose() {
      this.$bvModal.hide(this.essayModalId);
      this.loadData();
      this.isModalActive = false;
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    // onFiltered(filteredItems) {
    //   // `filteredItems` es un array de objetos que pasan el filtro
    //   // Puedes realizar acciones adicionales con los datos filtrados si es necesario
    //   console.log('Datos filtrados:', filteredItems);

    //   // Por ejemplo, puedes contar el número de elementos filtrados
    //   const numberOfFilteredItems = filteredItems.length;
    //   console.log('Número de elementos filtrados:', numberOfFilteredItems);

    //   // O calcular alguna estadística basada en los datos filtrados
    //   // ...

    //   // También puedes emitir un evento para informar al componente padre sobre los datos filtrados
    //   this.$emit('filtered-data', filteredItems);
    // },
    handleModalAction(actionType, essay) {
      this.$bvModal.hide(this.essayViewModalId);
      this.action = {
        description: "",
        essay_id: null,
      };
      this.actionType = actionType;
      this.essayId = essay;
      this.$bvModal.show(this.essayActionModalId);
    },

    successAction() {
      this.loadData();
    },

    setEssay(essay) {
      this.essayEdit = essay;
      // if (essay.current_step === 3) {
      //   this.essayURL = essay.url;
      //   this.viewPDF();
      // }
    },

    toggleDelete(id, itemId) {
      Swal.fire({
        title: "¿Estás seguro que quieres eliminar este proyecto?",
        text: "Una vez eliminado no podrá recuperarlo",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Sí, borrar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          const apiEndpoint = `/api/v1/essays/${itemId}`;

          api.delete({ url: apiEndpoint }).then((response) => {
            Swal.fire({
              title: "Solicitud completada",
              text: response?.data?.message,
              icon: "success",
              showConfirmButton: true,
              timer: 2000,
            });
            this.loadData();
          });
        }
      });
    },
  },
};
</script>
<template>
  <div>
    <EssayModal
      :id="essayModalId"
      :project_id="id"
      :essay="essayEdit"
      :isActive="isModalActive"
      :currentStep="currentStep"
      @updatedEssay="setEssay"
      @success="success"
      @close="handleModalClose"
    />
    <EssayViewModal
      :id="essayViewModalId"
      :essay="essayEdit"
      @open-action-modal="handleModalAction"
    />
    <EssayActionModal
      :id="essayActionModalId"
      :actionType="actionType"
      :essayId="essayId"
      :action="action"
      @success="successAction"
    />
    <EssayPdfViewModal :url="essayURL" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <button
              v-if="showElement([3])"
              @click="addEssay()"
              class="btn btn-success mb-4"
            >
              <i class="fa fa-plus"></i> Redactar proyecto
            </button>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;registros
                  </label>
                </div>
              </div>
              <!-- <div class="col-sm-12 col-md-6">
                <h4 class="card-title">Lista de proyectos</h4>
              </div> -->
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Buscar..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="listEssays"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                :busy.sync="isBusy"
                show-empty
              >
                <template v-slot:cell(essayStatus)="row">
                  <div>
                    <div>
                      <b-badge
                        pill
                        :variant="
                          row.item.essay_status_id === 3
                            ? 'warning'
                            : row.item.essay_status_id === 4
                            ? 'danger'
                            : 'info'
                        "
                        class="ml-1"
                      >
                        {{ row.item.essayStatus }}
                      </b-badge>
                    </div>
                  </div>
                </template>
                <template v-slot:cell(type)="row">
                  <div>
                    <div>
                      <b-badge
                        pill
                        :variant="
                          row.item.type === 'new' ? 'primary' : 'info'
                        "
                        class="ml-1"
                      >
                        {{
                          statusHelper.getStatus({
                            itemStatus: row.item.type,
                            type: 'essayType'
                          })
                        }}
                      </b-badge>
                    </div>
                  </div>
                </template>
                <template v-slot:cell(current_step)="row">
                  <div>
                    <div>
                      <b-badge
                        pill
                        :variant="
                          row.item.current_step === 3 ? 'success' : 'warning'
                        "
                        class="ml-1"
                      >
                        {{
                          row.item.current_step === 3
                            ? "Finalizado"
                            : "Incompleto (Paso " +
                              (row.item.current_step + 1) +
                              ")"
                        }}
                      </b-badge>
                    </div>
                  </div>
                </template>
                <template v-slot:cell(action)="row">
                  <div>
                    <!-- Mostrar el icono de editar si el rol es 3 y current_step no es 3 y el essay_status es 3 -->
                    <a
                      v-if="
                        showElement(
                          [3],
                          row.item?.current_step != 3,
                          row.item?.essay_status_id != 3
                        )
                      "
                      href="javascript:void(0);"
                      class="mr-3 text-secondary"
                      title="Edit"
                      @click="editEssay(row.item)"
                    >
                      <i class="mdi mdi-square-edit-outline font-size-18"></i>
                    </a>
                    <a
                      v-else-if="
                        showElement(
                          [3],
                          row.item?.current_step == 3,
                          row.item?.essay_status_id == 3
                        )
                      "
                      href="javascript:void(0);"
                      class="mr-3 text-secondary"
                      title="Edit"
                      @click="editEssay(row.item)"
                    >
                      <i class="mdi mdi-square-edit-outline font-size-18"></i>
                    </a>
                    <!-- <a v-if="showElement([1, 3], row.item?.current_step == 3, row.item?.essay_status_id != 3)" href="javascript:void(0);" class="mr-3 text-secondary" title="View" @click="viewEssay(row.item)">
                      <i class="mdi mdi-eye-outline font-size-18"></i>
                    </a> -->
                    <!-- Mostrar el icono de vista si el rol es 1 y current_step es 3 y el essay_status no es 3 -->
                    <router-link
                      v-if="
                        showElement(
                          [1, 3],
                          row.item?.current_step == 3,
                          row.item?.essay_status_id != 3
                        )
                      "
                      class="mr-3 text-secondary"
                      :to="{
                        name: 'essay-detail',
                        params: { id: id, essayId: row.item.id },
                      }"
                    >
                      <i class="mdi mdi-eye-outline font-size-18"></i>
                    </router-link>
                    <button
                      @click="toggleDelete(id, row.item.id)"
                      type="button"
                      class="btn btn-sm pl-0 shadow-none"
                      id="vertical-menu-btn"
                      v-if="showElement([1])"
                    >
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </template>
              </b-table>
              <div
                v-if="isBusy"
                class="text-center text-success my-2 table-spinner"
              >
                <b-spinner class="align-middle"></b-spinner>
              </div>
              <div v-else-if="totalRows == 0">
                <div class="text-center p-3">
                  <p></p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
